
<template>
    <div class="center examplex">
        
      <vs-button
        :disabled="cicloEscolar == ''"
        @click="activeAgregar=!activeAgregar"
        class="ml-auto"
        color="#7d33ff"
      >
        <i class="fas fa-plus mr-1"></i> Agregar
      </vs-button>
      <vs-table striped>
        <template #thead>
          <vs-tr>
            <vs-th>
              Materias
            </vs-th>
            <vs-th>
              Promediar
            </vs-th>
            <vs-th width="200px">
              Tipo de acción
            </vs-th>
            <vs-th width="70px">
              Acciones
            </vs-th>
          </vs-tr>
        </template>
        <template #tbody>
          <vs-tr
            :key="i"
            v-for="(tr, i) in info"
            :data="tr"
          >
            <vs-td>
              {{ tr.nombre }}
            </vs-td>
            <vs-td class="d-flex">
              <md-chip class="mb-1 fontMedium mini-chip col-green">
                  <strong>
                      <span style="text-transform: capitalize"> {{tr.promediar}}</span>
                  </strong>
              </md-chip>
            </vs-td>
            <vs-td>
              <md-chip class="mb-1 fontMedium mini-chip col-blue">
                  <strong>
                      <span style="text-transform: capitalize"> {{tr.accion}}</span>
                  </strong>
              </md-chip>
            </vs-td>
            <vs-td class="d-flex">
                <vs-button
                    @click="activeEditar=!activeEditar, selectedInfo = tr"
                    success
                    flat
                >
                    <i class="fas fa-edit mr-1"></i> Editar
                </vs-button>

                <vs-button
                    danger
                    @click="activeEliminar=!activeEliminar, selectedInfo = tr"
                    flat
                >
                    <i class="far fa-trash-alt mr-1"></i> Eliminar
                </vs-button>
            </vs-td>
          </vs-tr>
        </template>
        <template #notFound>
            No hay registros
        </template>
      </vs-table>
      <agregar v-model="activeAgregar" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getInfo()"></agregar>
      <editar v-model="activeEditar" :row="selectedInfo" :institucion="institucion" :cicloEscolar="cicloEscolar" @refreshTable="getInfo()"></editar>
      <eliminar v-model="activeEliminar" :row="selectedInfo" @refreshTable="getInfo()"></eliminar>
    </div>
</template>
<script>
import agregar from './modales/agregar.vue'
import editar from './modales/editar.vue'
import eliminar from './modales/eliminar.vue'
    export default {
      props: [
        'institucion',
        'cicloEscolar',
        'info'
      ],
      data:() => ({
        activeAgregar: false,
        activeEditar: false,
        activeEliminar:false,
        selectedInfo: [],
        materias: [
          {
            "nombre": "Matematicas",
            "promediar": "Faltas",
            "accion": "promedio",
          },
        ],
      }),
      components:{
          agregar,
          editar,
          eliminar
      },
      methods: {
        getInfo(){
          this.$emit('refreshTable')
        }
      }
    }
</script>
<style scoped>

    .col-green{
        color: #55ce63 !important;
        background: rgb(232, 253, 235) !important;
    }
    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }
</style>

        